import MediumDashboardView from "src/sections/dashboards/platforms/medium/medium-dashboard-view";

const MediumMainDashboardPage = () => <MediumDashboardView type="main" />;

export default MediumMainDashboardPage;
